import { Edge, useGraphInstance, Node, Cell } from "@antv/xflow"
import { NodeCellPanel } from "./NodeCellPanel"
import { EdgeCellPanel } from "./EdgeCellPanel"

interface CellPanelProps {
  cell: Cell
  onChange?: () => void
}

export const CellPanel = (props: CellPanelProps) => {
  const {cell, onChange} = props;
  const graph = useGraphInstance();

  if (!cell || !graph) return null;

  if (graph.isNode(cell)) {
    return <NodeCellPanel cell={cell} onChange={onChange} />
  }

  if (graph.isEdge(cell)) {
    return <EdgeCellPanel edge={cell} />
  }
}